module.exports = __webpack_public_path__ + "img/popinjays.1d49cf9e.png";